import React from 'react';
import PropTypes from 'prop-types';
import Amplify from 'aws-amplify';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withAlert } from 'react-alert';
import {
  getSettlemetEnrichmentQuestion,
  getAllSettlement,
  saveSettlementAnswers,
  getEnrollSettlementForUser,
  getAlLFeatureSettlement,
  saveEnrichmentAnswer,
  getAllCategory,
  getSettlementListByAffiliateType,
  getEnrolledListByAffiliateId,
  getAffiliateUser,
} from '../../../Actions/actions';
import * as SecretKeys from '../../../ENV.json';
import EnrollementListComponent from './enrollementListComponent';

Amplify.configure(SecretKeys.awsUserpool);

class EnrollmentListContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allSettlementData: {},
      selectedMenuItem: 'dashboard',
      userid: localStorage.getItem('userId'),
      settlementIdE: 0,
      isLoader: false,
      intervalId: 0,

    };
    this.saveEnrichmentAnswer = this.saveEnrichmentAnswer.bind(this);
    this.saveAnserTOQuestion = this.saveAnserTOQuestion.bind(this);
  }

  saveAnserTOQuestion(questionObj) {
    this.props.saveSettlementAnswers(questionObj);
  }

  componentDidMount() {
    // const id = this.props.match.params.settlementId;
    const intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
    // console.log('this.props.match.params.settlementId', this.props.match.params.settlementId)
    // if (id !== undefined) {
    //   this.props.getEnrolledListByAffiliateId({
    //     settlementId: id,
    //     pageNumber: 0,
    //     pageSize: 10,
    //     searchKeyword: '',
    //     userId: this.state.userid,
    //   });
    //   this.setState({ settlementIdE: id });
    // } else {
    //   this.props.getEnrolledListByAffiliateId({
    //     settlementId: 0,
    //     pageNumber: 0,
    //     pageSize: 10,
    //     searchKeyword: '',
    //     userId: this.state.userid,
    //   });
    // }
    this.props.getAffiliateUser(this.state.userid);
    this.setState({
      isLoader: true,
      intervalId,
    });
  }

  scrollStep = () => {
    if (window.pageYOffset === 0) {
      clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  }

  componentDidUpdate() {
    const {
      GetAffiliateUser,

    } = this.props.data;
    const { match: { params } } = this.props
    const {
      GetAffiliateUserData,
      settlementIdData
    } = this.state;


    if (settlementIdData !== (params.settlementId ? params.settlementId : 0)) {
      if (params && params.settlementId) {
        this.props.getEnrolledListByAffiliateId({
          settlementId: params.settlementId,
          pageNumber: 0,
          pageSize: 10,
          searchKeyword: '',
          userId: this.state.userid,
        });
      } else {
        this.props.getEnrolledListByAffiliateId({
          settlementId: 0,
          pageNumber: 0,
          pageSize: 10,
          searchKeyword: '',
          userId: this.state.userid,
        });
      }
      this.setState({ settlementIdData: params.settlementId ? params.settlementId : 0 });


    }
    if (GetAffiliateUserData !== GetAffiliateUser) {
      this.setState({
        GetAffiliateUserData: GetAffiliateUser,
      });
      if (GetAffiliateUser.affiliateType !== undefined) {
        this.props.getSettlementListByAffiliateType({
          searchKeyword: '',
          affiliateType: GetAffiliateUser.affiliateType,
          userId: this.state.userid,
        });
      }
    }
  }


  // shouldComponentUpdate(nextProps, nextState) {
  //   if (this.state !== nextState || this.props !== nextProps) {
  //     return true;
  //   }
  //   return false;
  // }

  componentWillReceiveProps(nextProps) {
    const settleRecord = nextProps.data.settlementEnrolledDataAffiliateData;
    this.setState({
      allSettlementData: settleRecord,
      // AllCategoryData: AllCategory,
    });
  }

  saveEnrichmentAnswer(queId, ans) {
    const data = {
      userId: this.state.userid,
      value: ans,
      enrichmentQuestionId: queId,
    };
    this.props.saveEnrichmentAnswer(data);
  }

  render() {
    const {
      selectedMenuItem,
      allSettlementData,
      isLoader,
      // AllCategoryData,
    } = this.state;
    return (
      <div className="container">
        <span />
        <div className="main-content bg-grey">
          <EnrollementListComponent
            allSettlementDatawe={allSettlementData}
            selectedMenuItem={selectedMenuItem}
            // allCategoryDatawe={AllCategoryData}
            answerToQuestionAction={this.saveAnserTOQuestion}
            settlementIdE={this.state.settlementIdE}
            Loader={isLoader}
          />
        </div>
      </div>
    );
  }
}

EnrollmentListContainer.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getSettlemetEnrichmentQuestion,
      getAllSettlement,
      saveSettlementAnswers,
      getEnrollSettlementForUser,
      getAlLFeatureSettlement,
      saveEnrichmentAnswer,
      getAllCategory,
      getEnrolledListByAffiliateId,
      getSettlementListByAffiliateType,
      getAffiliateUser,
    },
    dispatch,
  );

export default withAlert(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(EnrollmentListContainer),
);
